<h1 mat-dialog-title>
  <div [ngSwitch]="type">
    <mat-icon class="icon-md" color="warn" *ngSwitchCase="dialogType.Warning"
      >warning</mat-icon
    >
    <span *ngSwitchCase="dialogType.None"></span>
    {{ title }}
  </div>
</h1>

<div mat-dialog-content>
  <p>{{ message }}</p>
  <form [formGroup]="rejectForm">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Reason for Rejection</mat-label>
      <textarea
        matInput
        formControlName="reason"
        placeholder="Enter reason"
        rows="2"
      ></textarea>
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions>
  <button
    [color]="cancelColor"
    *ngIf="variant === dialogVariant.YesNo"
    mat-raised-button
    (click)="onDismiss()"
  >
    No
  </button>
  <button mat-raised-button [color]="confirmColor" (click)="onConfirm()">
    {{ variant === dialogVariant.YesNo ? "Yes" : "OK" }}
  </button>
</div>
